export default __webpack_public_path__ + "static/media/logo2.da2a8c22.png";